var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2929 5.29289C20 5.58579 20 6.05719 20 7V20C20 20.9428 20 21.4142 20.2929 21.7071C20.5858 22 21.0572 22 22 22C22.9428 22 23.4142 22 23.7071 21.7071C24 21.4142 24 20.9428 24 20V7C24 6.05719 24 5.58579 23.7071 5.29289C23.4142 5 22.9428 5 22 5C21.0572 5 20.5858 5 20.2929 5.29289Z",
    fill: "#FFB823"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10C13 9.05719 13 8.58579 13.2929 8.29289C13.5858 8 14.0572 8 15 8C15.9428 8 16.4142 8 16.7071 8.29289C17 8.58579 17 9.05719 17 10V20C17 20.9428 17 21.4142 16.7071 21.7071C16.4142 22 15.9428 22 15 22C14.0572 22 13.5858 22 13.2929 21.7071C13 21.4142 13 20.9428 13 20V10Z",
    fill: "#FFB823"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.29289 12.2929C6 12.5858 6 13.0572 6 14V20C6 20.9428 6 21.4142 6.29289 21.7071C6.58579 22 7.05719 22 8 22C8.94281 22 9.41421 22 9.70711 21.7071C10 21.4142 10 20.9428 10 20V14C10 13.0572 10 12.5858 9.70711 12.2929C9.41421 12 8.94281 12 8 12C7.05719 12 6.58579 12 6.29289 12.2929Z",
    fill: "#FFB823"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6 24.25C5.58579 24.25 5.25 24.5858 5.25 25C5.25 25.4142 5.58579 25.75 6 25.75H24C24.4142 25.75 24.75 25.4142 24.75 25C24.75 24.5858 24.4142 24.25 24 24.25H6Z",
    fill: "#FFB823"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.563ad4bac60f18c9179fe046e7736860.svg";
export { ForwardRef as ReactComponent };